import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

export type ChipVariant =
  | 'default'
  | 'registered'
  | 'external'
  | 'team_member'
  | 'current_user'
  | 'pending'
  | 'paid'
  | 'overdue'
  | 'cancelled'
  | 'unpaid'
  | 'canceled'
  | 'disputed'

export interface StatusChipProps {
  variant: ChipVariant
  children: React.ReactNode
  className?: string
}

const getVariantStyle = (variant: ChipVariant) => {
  switch (variant) {
    case 'registered':
      return styles.registered
    case 'external':
      return styles.external
    case 'team_member':
      return styles.teamMember
    case 'current_user':
      return styles.currentUser
    case 'pending':
      return styles.pending
    case 'paid':
      return styles.paid
    case 'overdue':
      return styles.overdue
    case 'cancelled':
    case 'canceled':
      return styles.cancelled
    case 'unpaid':
      return styles.unpaid
    case 'disputed':
      return styles.disputed
    default:
      return styles.default
  }
}

const StatusChip: React.FC<StatusChipProps> = ({
  variant,
  children,
  className,
}) => {
  const baseClasses = css(styles.chip, getVariantStyle(variant))
  const finalClassName = className ? `${baseClasses} ${className}` : baseClasses

  return <span className={finalClassName}>{children}</span>
}

const styles = StyleSheet.create({
  chip: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: '12px',
    display: 'inline-block',
  },
  default: {
    backgroundColor: '#F3F4F6',
    color: '#6B7280',
  },
  registered: {
    backgroundColor: '#DEF7EC',
    color: '#03543F',
  },
  external: {
    backgroundColor: '#FEF3C7',
    color: '#92400E',
  },
  teamMember: {
    backgroundColor: '#E0F2FE',
    color: '#007BFF',
  },
  currentUser: {
    backgroundColor: '#F3E8FF',
    color: '#7C3AED',
  },
  pending: {
    backgroundColor: '#FEF3C7',
    color: '#92400E',
  },
  paid: {
    backgroundColor: '#D1FAE5',
    color: '#065F46',
  },
  overdue: {
    backgroundColor: '#FEE2E2',
    color: '#991B1B',
  },
  cancelled: {
    backgroundColor: '#F3F4F6',
    color: '#374151',
  },
  unpaid: {
    backgroundColor: '#F3F4F6',
    color: '#6B7280',
  },
  disputed: {
    backgroundColor: '#FEF3C7',
    color: '#92400E',
  },
})

export default StatusChip
